import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['template', 'container', 'item', 'alternativesSection'];

  connect() {
    this.toggleVisibility();
  }

  add(event) {
    event.preventDefault();
    const content = this.templateTarget.content.cloneNode(true);
    this.containerTarget.appendChild(content);
  }

  remove(event) {
    event.preventDefault();
    const item = event.target.closest('[data-topic-alternatives-target="item"]');
    if (this.itemTargets.length > 1) {
      item.remove();
    }
  }

  toggleVisibility() {
    const isChecked = this.checkbox.checked;
    if (isChecked) {
      this.alternativesSectionTarget.classList.remove('tw-hidden');
    } else {
      this.alternativesSectionTarget.classList.add('tw-hidden');
    }
  }

  get checkbox() {
    return this.element.querySelector("input[type='checkbox']");
  }
}
